const swiperMapSlider = new Swiper('.map__slider', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    speed: 800,
    watchSlidesProgress: true,
    pagination: {
      el: ".map__slider-pagination",
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        loop: false,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 'auto',
        loop: false,
        spaceBetween: 0,
      },
    },
    autoplay: {
      delay: 4000, 
      disableOnInteraction: false,
    },
});

function toggleAutoplay(swiper) {
  if (window.innerWidth >= 768) {
    swiper.autoplay.stop();
  } else {
    swiper.autoplay.start();
  }
}

toggleAutoplay(swiperMapSlider);

window.addEventListener('resize', () => toggleAutoplay(swiperMapSlider));